
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.083","height":"38.25","viewBox":"0 0 23.083 38.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#212225","d":"M7.816 18.889L22.483 4.223a.63.63 0 000-.891L19.335.184a.63.63 0 00-.891 0L.185 18.444a.63.63 0 000 .891l18.259 18.259a.63.63 0 00.89 0l3.148-3.148a.63.63 0 000-.891L7.816 18.889z"}})])
          )
        }
      }
    